import { apiV1OnlineAddresses }	from './resources/api-v1-online-addresses';

export default  {
	apiV1OnlineAddresses,
}